import { Grid } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";

export const Container = styled(Grid)({
  minHeight: "60px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "30px",
  padding: "0 15px",

  "& > .MuiGrid-root:nth-of-type(2)": {
    display: "flex",
    flex: 1,
  },
});

export const DocTypeContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "20px",

  ".MuiTypography-root": {
    minWidth: "150px",
    color: theme.palette.primary.main,
  },

  ".MuiButton-root": {
    color: theme.palette.primary.main,
    border: "none",

    "&:hover": {
      border: "none",
    },
  },
}));

export const Document = styled(Grid)(({ theme }) => ({
  width: "60px",
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  flexWrap: "wrap",
  cursor: "pointer",

  "& svg": {
    fontSize: "1.8em",
    color: theme.palette.primary.main,
  },

  "& .MuiTypography-root": {
    fontSize: "0.7em",
  },
}));

export const Actions = styled(Grid)({
  width: "20%",
  display: "flex",
  justifyContent: "flex-end",
  gap: "20px",
});

export const FilesInfo = styled(Grid)(({ theme }) => ({
  height: "100%",
  display: "flex",
  alignItems: "center",
  position: "relative",

  ".MuiGrid-root": {
    visibility: "hidden",
    opacity: 0,
    transition: "all .3s ease",
    border: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
    backgroundColor: lighten(theme.palette.secondary.light, 0.5),
    padding: "10px",
    position: "absolute",
    bottom: "40px",
    right: 0,
    zIndex: 99,
  },

  ".MuiButton-root:hover + .MuiGrid-root, .MuiGrid-root:hover": {
    visibility: "visible",
    opacity: 1,
  },
}));
